import common from "@/common";

export default [
  {
    name: 'companyName',
    label: 'common.company',
    type: 'text',
    show: common.isAdmin(),
    edit_disable: true
  },
  {
    name: 'facilityName',
    label: 'common.facility',
    type: 'text',
    slot: 'facility',
    show: common.isAdmin(),
    edit_disable: true
  },
  {
    name: 'floorName',
    label: 'common.floor',
    type: 'text',
    slot: 'floor',
    edit_disable: true
  },
  {
    name: 'roomName',
    label: 'common.room',
    type: 'text',
    edit_disable: true
  },
  {
    name: 'bedNumber',
    label: 'common.bed',
    type: 'text',
    edit_disable: true
  },
  {
    name: 'memberCode',
    label: 'member.memberCode',
    type: 'text',
    edit_show: true,
    edit_disable: true
  },
  {
    name: 'chineseName',
    label: 'member.chineseName',
    type: 'text',
    edit_disable: true
  },
  {
    name: 'englishName',
    label: 'member.englishName',
    type: 'text',
    edit_disable: true
  },
  {
    name: 'faceID',
    label: 'FaceID',
    type: 'text',
    edit_disable: true
  },
  {
    name: 'photos',
    label: '更新照片',
    rule: 'required',
    validate_in_slot: true,
    type: 'slot',
    slot: 'photos',
    slot_config: {
      name: 'photos',
      label: '更新照片',
      type: 'file',
      file_accept: '.png,.jpg,.jpeg,.jfif',
      placeholder: common.getI18n('kiosk.placeholder').replace('{_type_}', '.png, .jpg, .jpeg, .jfif'),
      rule: 'required',
      max_count: 1,
      show_del_btn: false,
      show_add_btn: false,
    },
  },
]
